import { defineComponent as _defineComponent, resolveComponent as _resolveComponent2, createVNode as _createVNode2 } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  style: {
    "line-height": "50px"
  }
};
import { PAGE_MINE_URL } from '@/api/system/message-view';
import { createFormItem } from '@/component-create/utils/create-form-item';
import { SearchForm } from '@/component-create/SearchForm';
import { Table } from '@/component-create/Table';
import { FORM_ITEM } from '@/components/form/enums';
import { MESSAGE_READ_STATUS, MESSAGE_TYPE } from '@/constant/system/code';

import { h, ref, nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Notification',
  setup: function setup(__props) {
    var column = [{
      type: 'index',
      label: '索引',
      width: '60'
    }, {
      label: '状态',
      prop: 'readStatus',
      sortable: true,
      align: 'center',
      width: '80',
      slot: function slot(row) {
        return h(_createVNode2(_resolveComponent2("el-tag"), {
          "type": "success",
          "size": "small"
        }, {
          default: function _default() {
            return [row.readStatus === MESSAGE_READ_STATUS.UNREAD.CODE ? MESSAGE_READ_STATUS.UNREAD.NAME : MESSAGE_READ_STATUS.READ.NAME];
          }
        }));
      }
    }, {
      label: '主题',
      prop: 'subject'
    }, {
      label: '类型',
      prop: 'type',
      align: 'center',
      width: '80',
      slot: function slot(row) {
        return h(_createVNode2(_resolveComponent2("el-tag"), {
          "type": "success",
          "size": "small"
        }, {
          default: function _default() {
            return [row.type === MESSAGE_TYPE.NOTICE.CODE ? MESSAGE_TYPE.NOTICE.NAME : MESSAGE_TYPE.MESSAGE.NAME];
          }
        }));
      }
    }, {
      label: '作者',
      prop: 'author',
      width: '120'
    }, {
      label: '发布时间',
      prop: 'pubDate',
      align: 'center',
      width: '160',
      sortable: true
    }, {
      label: '操作',
      align: 'center',
      width: '100',
      slot: 'action',
      controller: [{
        icon: 'View',
        handler: function handler() {
          // 
        },
        text: '查看'
      }]
    }];
    var elTableProps = {
      border: true
    };
    var url = PAGE_MINE_URL;
    var editForm = ref();
    var tableRef = ref();
    var visible = ref(false);
    var searchForm = null;
    var table = null;
    function handleClose() {
      visible.value = false;
    }
    function open() {
      visible.value = true;
      if (!searchForm) {
        nextTick(function () {
          createForm();
          createTable();
        });
      }
    }
    function createForm() {
      var items = [createFormItem('主题', 'subject', FORM_ITEM.INPUT, {
        placeholder: '请输入主题'
      }), createFormItem('类型', 'type', FORM_ITEM.SELECT, {
        placeholder: '请选择类型',
        loader: 'MESSAGE_TYPE',
        allOption: true,
        default: true,
        defaultOnNull: true
      }), createFormItem('状态', 'readStatus', FORM_ITEM.SELECT, {
        placeholder: '请选择状态',
        loader: 'MESSAGE_READ_STATUS',
        allOption: true,
        default: true,
        defaultOnNull: true
      })];
      searchForm = new SearchForm(editForm.value, items);
      searchForm.onReset = function () {
        // 
      };
      searchForm.onSearch = function (formData) {
        if (formData && table) {
          table.load(formData);
        }
      };
    }
    function createTable() {
      table = new Table(tableRef.value, column, [], elTableProps, url);
    }
    return function (_ctx, _cache) {
      var _component_el_dialog = _resolveComponent("el-dialog");
      var _component_IEpBell = _resolveComponent("IEpBell");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(visible) ? visible.value = $event : null;
        }),
        title: "我的公告/消息",
        width: "70%",
        "before-close": handleClose,
        "max-height": "700px"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", {
            ref_key: "editForm",
            ref: editForm
          }, null, 512), _createElementVNode("div", {
            ref_key: "tableRef",
            ref: tableRef
          }, null, 512)];
        }),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", {
        onClick: open
      }, [_createVNode(_component_IEpBell, {
        style: {
          "width": "20px",
          "height": "20px",
          "position": "relative",
          "top": "4px"
        }
      })])]);
    };
  }
});